import { DatePipe } from '@angular/common';
import { Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { takeUntil } from 'rxjs/operators';
import { tsXLXS } from 'ts-xlsx-export';;
import { Subject } from 'rxjs';
import { Login, Favorecido, EddyAutoComplete, GlobalService, FuncaoService, Coluna, Relatorio, FavorecidoService, TipoContratacao } from 'eddydata-lib';
import { FuncaoGovernoService, RecursoService, ContratoService } from 'administrativo-lib';
import { TipoContratacaoService } from '../../tipo-contratacao/service/tipo-contratacao.service';

@Component({
  selector: 'app-contrato-rpt',
  templateUrl: './contrato-rpt.component.html'
})
export class ContratoRptComponent implements OnInit, OnDestroy {


  protected datepipe: DatePipe;
  login: Login = new Login();
  tipoContratacao: TipoContratacao;
  objeto: string;
  favorecido: Favorecido;
  filtroFavorecido: boolean;
  filtroContratacao: boolean;
  filtroValor: boolean;
  filtroObjeto: boolean;
  public selectedOrdem: string;
  public selectedData: string;

  public ptBR: any;

  public listaRelatorio: Array<any>;
  public listaContratacao: TipoContratacao[];
  public favorecidoAutoComplete: EddyAutoComplete<Favorecido>;
  public relatorio = '1';
  public dataInicial: string;
  public dataFinal: string;
  public valorInicial: number;
  public valorFinal: number;
  protected unsubscribe: Subject<void> = new Subject();

  imaskConfig = {
    mask: Number,
    scale: 2,
    thousandsSeparator: '.',
    padFractionalZeros: true,
    normalizeZeros: true,
    radix: ','
  };

  constructor(
    private router: Router,
    protected injector: Injector,
    protected messageService: MessageService,
    protected globalService: GlobalService,
    protected funcaoService: FuncaoService,
    protected funcaoGovernoService: FuncaoGovernoService,
    protected contratacaoService: TipoContratacaoService,
    protected recursoService: RecursoService,
    protected favorecidoService: FavorecidoService,
    protected contratoService: ContratoService) {
  }

  ngOnInit() {
    this.ptBR = this.globalService.obterDataBR();
    this.login = GlobalService.obterSessaoLogin();
    this.selectedOrdem = 'ord1';
    this.selectedData = 'dt1';
    this.listaRelatorio = [];
    this.listaRelatorio.push({ label: 'TODOS OS CONTRATOS E ADITIVOS', value: 1 });
    this.listaRelatorio.push({ label: 'FILTRAR SOMENTE CONTRATOS', value: 2 });
    this.listaRelatorio.push({ label: 'FILTRAR SOMENTE ADITIVOS', value: 3 });
    this.contratacaoService.filtrar(0, 0, { orgao_id: this.login.orgao.id }).pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.listaContratacao = res ? res.content : [];
      }, error => toastr.error(error.message ? error.message : error));

    // autocomplete para favorecido
    this.favorecidoAutoComplete = new EddyAutoComplete(null, this.favorecidoService,
      'id', ['cpf_cnpj', 'nome'], { cidade_id: this.login.cidade.id, orderBy: 'nome' }, { number: ['id', 'cpf_cnpj'], text: ['nome'] }
    );
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public gerarRelatorio() {
    const parametros = {};
    if ((!this.dataInicial || !this.dataFinal) || (this.dataInicial === '' || this.dataFinal === '')) {
      this.messageService.add({ severity: 'warn', summary: 'Menssagem', detail: 'Informe a data inicial e final!' });
      return;
    }

    if (this.selectedData === 'dt1') {
      parametros['data_inicio$ge'] = this.funcaoService.converteDataSQL(this.dataInicial);
      parametros['data_inicio$le'] = this.funcaoService.converteDataSQL(this.dataFinal);
    } else {
      parametros['data_termino$ge'] = this.funcaoService.converteDataSQL(this.dataInicial);
      parametros['data_termino$le'] = this.funcaoService.converteDataSQL(this.dataFinal);
    }

    if (this.filtroValor) {
      parametros['valor_contrato$ge'] = this.funcaoService.converteValorSQL(this.valorInicial);
      parametros['valor_contrato$le'] = this.funcaoService.converteValorSQL(this.valorFinal);
    }

    if (this.filtroContratacao && this.tipoContratacao) {
      parametros['tipo_contratacao.id'] = this.tipoContratacao.id;
    }

    if (this.filtroObjeto) {
      parametros['objeto$like'] = `%${this.objeto}%`;
    }

    if (this.filtroFavorecido) {
      parametros['favorecido.id'] = this.favorecido.id;
    }

    if (this.relatorio === '2') {
      parametros['aditivo$not_null'] = '';
    } else if (this.relatorio === '3') {
      parametros['aditivo$null'] = '';
    }

    if (this.selectedOrdem === 'ord1') {
      parametros['orderBy'] = 'data_inicio';
    } else if (this.selectedOrdem === 'ord2') {
      parametros['orderBy'] = 'numero';
    } else if (this.selectedOrdem === 'ord3') {
      parametros['orderBy'] = 'favorecido.nome';
    } else if (this.selectedOrdem === 'ord4') {
      parametros['orderBy'] = 'valor_contrato';
    }
    parametros['relations'] = 'favorecido';
    parametros['orgao_id'] = this.login.orgao.id;

    this.contratoService.filtrar(1, -1, parametros)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((lista) => {
        this.imprimir(`LISTAGEM NO PERÍODO DE ${this.dataInicial} à ${this.dataFinal} `,
          this.login.usuario.nome, this.login.orgao.nome, this.login.brasao, 'landscape',
          'Listagem contratos', ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', '*', 'auto'], lista.content);
      });
  }

  private imprimir(
    titulo: string, usuario: string, orgao: string,
    brasao: string, orientacao: 'landscape' | 'portrait', nomepdf?: string, largura?: string[], lista?: any[]) {
    Relatorio.imprimir(titulo, usuario, orgao, brasao, lista, this.colunas(), orientacao, nomepdf, largura, ['valor_contrato']);
  }

  colunas(): string[] | Coluna[] {
    return [
      { titulo: 'Número', coluna: 'numero' },
      { titulo: 'data Início', coluna: 'data_inicio' },
      { titulo: 'data Término', coluna: 'data_termino' },
      { titulo: 'Favorecido', coluna: 'favorecido.nome' },
      { titulo: 'Contratação', coluna: 'tipo_contratacao.nome'},
      { titulo: 'Processo', coluna: 'processo' },
      { titulo: 'Objeto', coluna: 'objeto' },
      { titulo: 'Valor Contratado', coluna: 'valor_contrato', decimais: 2 }
    ];
  }

  exportarXlxs() {
    const parametros = {};
    parametros['orgao.id'] = this.login.orgao.id;
    parametros['relations'] = 'favorecido';
    parametros['orderBy'] = 'codigo';
    this.contratoService
      .filtrar(1, -1,
        parametros
      )
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        lista => {
          const listaItens = new Array();
          for (const item of lista.content) {
            const entity = {
              codigo: item.codigo,
              cpf: item.cpf,
              nome: item.pessoa.nome,
              endereco: item.pessoa.endereco,
              bairro: item.pessoa.bairro,
              cidade: item.pessoa.municipio,
              telefone: item.pessoa.telefone,
              cep: item.pessoa.cep
            };
            listaItens.push(entity);
          }
          tsXLXS().exportAsExcelFile(listaItens).saveAsExcelFile('funcionarios');
        },
        () => alert('erro ao retornar lista')
      );
  }

  sair() {
    this.funcaoService.navegarPara(this.login.usuario.sistema, this.router);
  }
}
